// Fixed-menu dishes are independent copies, not positional references into the à-la-carte list.
const { categoryKey } = require('./menuStructure');
const blankFixedDish = () => ({ name: '', description: '', ingredients: '', allergens: [], allergenStatus: 'unknown', frozen: false, verified: false });
const blankCourse = () => ({ name: '', choice: 'all', dishes: [] });
const blankFixedMenu = () => ({ name: '', price: '', description: '', included: '', excluded: '', availability: '', available: true, courses: [] });
function copyFixedDish(item, { demo = false } = {}) {
  const verified = !demo && item.verified === true && item.allergenStatus === 'declared';
  return { ...blankFixedDish(), name: item.name, description: item.description || '', ingredients: item.ingredients || '', allergens: [...(item.allergens || [])], frozen: item.frozen === true,
    verified, allergenStatus: verified ? 'declared' : 'unknown' };
}
function fixedMenuIssues(fixed, demo = false) {
  const issues = [];
  if (!fixed.name?.trim()) issues.push('Nome del menù');
  if (fixed.price == null || fixed.price === '' || !Number.isFinite(Number(fixed.price)) || Number(fixed.price)<0) issues.push('Prezzo a persona');
  if (!fixed.courses?.length) issues.push('Almeno una portata');
  for (const course of fixed.courses || []) {
    if (!course.name?.trim() || !course.dishes?.length) issues.push('Portata da completare');
    for (const dish of course.dishes || []) {
      if (!dish.name?.trim() || (!demo && (!dish.verified || dish.allergenStatus !== 'declared'))) issues.push(dish.name || 'Piatto da verificare');
    }
  }
  return issues;
}
function visibleFixedMenus(content) {
  return (content?.fixedMenus || []).filter(fixed => fixed.available !== false);
}
function fixedMenuText(fixed) {
  return categoryKey([fixed.name, fixed.description, fixed.availability, fixed.included, fixed.excluded,
    ...(fixed.courses || []).flatMap(course => [course.name, ...course.dishes.flatMap(dish => [dish.name, dish.description, dish.ingredients])])].join(' '));
}
function selectFixedMenus(content, question = '', limit = 2) {
  const query = categoryKey(question);
  const generic = /men[uù]\s+fiss[oi]|prezzo\s+fisso|degustazion/.test(query);
  const terms = query.match(/[\p{L}\p{N}]{3,}/gu) || [];
  if (!terms.length) return [];
  return visibleFixedMenus(content).filter(fixed => !fixedMenuIssues(fixed, content.demo).length)
    .map((fixed, index) => ({ fixed, index, score: terms.reduce((sum, term) => sum + Number(fixedMenuText(fixed).includes(term)), 0) }))
    .filter(match => generic || match.score > 0).sort((a,b) => b.score-a.score || a.index-b.index).slice(0,limit).map(match => match.fixed);
}
module.exports = { blankFixedDish, blankCourse, blankFixedMenu, copyFixedDish, fixedMenuIssues, visibleFixedMenus, fixedMenuText, selectFixedMenus };
